import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-72e50e06"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title-box" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "editor-box" }
const _hoisted_4 = { class: "ql-snow" }

import {onMounted, ref} from 'vue';
import {DateFieldType} from '@/components/business/crud/interface/FieldType';
import {WidgetInfo} from "@/components/business/crud/widgets/WidgetContainer"
import {ScForm} from "@/models/ScForm";
import {createQuill} from "@/util/editor";
import Quill from "quill";


import {definedWidgetMeta} from "@/components/business/crud/widgets/widgetManager";

export const meta = definedWidgetMeta({
  size: {edit: 'large', show: 'large'},
});

export default /*#__PURE__*/_defineComponent({
  __name: 'EditorForm.b',
  props: {
    propName: {},
    widget: {},
    info: {}
  },
  setup(__props: any) {

const props = __props;

const data = ScForm.useFormData();
const editor = ref<HTMLElement>();
const show = ref<HTMLElement>();
onMounted(() => {
  if (editor.value) {
    const quill = createQuill(editor.value, {placeholder: '请编辑' + props.info.title});
    quill.setContents(data.value[props.propName]);
    quill.on("text-change", () => {
      data.value[props.propName] = quill.getContents();
    });
  }
  if (show.value) {
    const quill = new Quill(show.value, {readOnly: true,  modules: {toolbar: "#notoolbar"}});
    quill.setContents(data.value[props.propName]);
    quill.disable()
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.info.title), 1)
    ]),
    _withDirectives(_createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          ref_key: "editor",
          ref: editor,
          class: "editor"
        }, null, 512)
      ])
    ], 512), [
      [_vShow, _ctx.info.status === 'edit']
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", {
        ref_key: "show",
        ref: show
      }, null, 512)
    ], 512), [
      [_vShow, _ctx.info.status === 'show']
    ])
  ], 64))
}
}

})